import { render, staticRenderFns } from "./kndErrorNotify.vue?vue&type=template&id=6104fc66&scoped=true&"
import script from "./kndErrorNotify.vue?vue&type=script&lang=js&"
export * from "./kndErrorNotify.vue?vue&type=script&lang=js&"
import style0 from "./kndErrorNotify.vue?vue&type=style&index=0&id=6104fc66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6104fc66",
  null
  
)

export default component.exports